<template>
  <div class="pa-2 m-category-view">
    <!-- ========================================== -->
    <!-- 1. بخش دسته‌بندی‌های اصلی (متن روی عکس) -->
    <!-- ========================================== -->
    <div class="d-flex justify-space-between align-center mb-4 px-2">
      <span class="text-subtitle-1 font-weight-black grey--text text--darken-3">منوی سفارش</span>
      <v-btn text small color="primary" class="font-weight-bold rounded-xl" @click="showAllCategoriesModal = true">
        مشاهده همه
        <v-icon right small>mdi-chevron-left</v-icon>
      </v-btn>
    </div>

    <!-- Swiper دسته‌های اصلی -->
    <swiper-wrapper
      v-if="rerender"
      ref="swiper"
      :loop="false"
      slides-per-view="auto"
      :space-between="16"
      class="mb-6 px-2 py-4"
      swipe-to
      wrapper-class="category-slider"
    >
      <div
        v-for="(item, i) in items"
        :key="`cat-${i}`"
        :class="{'active-cat' : computedValue === i}"
        class="swiper-slide cat-slide"
        @click="selectCategory(i)"
      >
        <div class="cat-avatar-wrapper mx-auto transition-swing">
          <v-avatar size="76" class="cat-avatar elevation-1">
            <v-img v-if="!!item.picture" :src="item.picture" :alt="item.name" style="object-fit: cover"/>
            <v-icon v-else size="36" :color="computedValue === i ? 'primary' : 'grey lighten-1'">
              mdi-food-fork-drink
            </v-icon>
          </v-avatar>
        </div>
        <div class="cat-name-box transition-swing">
          <span class="d-block text-truncate text-caption cat-text"
                :class="computedValue === i ? 'font-weight-bold' : 'font-weight-medium'">
            {{ item.name }}
          </span>
        </div>
      </div>
    </swiper-wrapper>

    <!-- ========================================== -->
    <!-- 2. بخش زیر دسته‌ها (طراحی کپسولی) -->
    <!-- ========================================== -->
    <div v-if="getSubs && getSubs.length" class="mb-4">
      <div class="d-flex justify-space-between align-center mb-3 px-2">
        <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">زیر دسته‌</span>
        <v-btn icon small @click="showAllSubCategoriesModal = true">
          <v-icon>mdi-dots-horizontal</v-icon>
        </v-btn>
      </div>

      <!-- Swiper زیردسته‌ها -->
      <swiper-wrapper
        :loop="false"
        :space-between="12"
        slides-per-view="auto"
        class="px-3 py-3"
        wrapper-class="sub-category-slider"
      >
        <div
          v-for="(item, i) in getSubs"
          :key="`sub-cat-${i}`"
          class="swiper-slide text-center sub-cat-slide"
          :class="{'active-sub-cat' : computedFilters.sub === item.id}"
          @click="selectSubCategory(item.id)"
        >
          <div class="sub-cat-pill transition-swing">
            <v-avatar size="36" class="sub-cat-avatar elevation-1">
              <v-img v-if="item.picture" :alt="item.name" :src="item.picture" style="object-fit: cover"/>
              <v-icon v-else size="20" :color="computedFilters.sub === item.id ? 'primary' : 'grey'">mdi-shape-outline</v-icon>
            </v-avatar>
            <span class="text-caption font-weight-bold ml-2 sub-cat-text"
                  :class="computedFilters.sub === item.id ? 'primary--text' : 'grey--text text--darken-3'">
              {{ item.name }}
            </span>
          </div>
        </div>
      </swiper-wrapper>
    </div>

    <!-- ========================================== -->
    <!-- 3. مُدال همه دسته‌بندی‌ها -->
    <!-- ========================================== -->
    <v-bottom-sheet v-model="showAllCategoriesModal" scrollable>
      <v-card class="rounded-t-xl pb-4">
        <v-card-title class="d-flex justify-space-between align-center pb-2 pt-4">
          <span class="text-h6 font-weight-black">همه دسته‌بندی‌ها</span>
          <v-btn icon color="grey" @click="showAllCategoriesModal = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-4" style="max-height: 70vh;">
          <v-row>
            <v-col cols="4" sm="3" class="text-center" @click="clearCategorySelection">
              <div class="cat-avatar-wrapper modal-cat-wrapper mx-auto mb-2 transition-swing" :class="{'active-modal-wrapper': computedValue === null}">
                <v-avatar size="76" class="cat-avatar elevation-1"><v-icon size="36" :color="computedValue === null ? 'primary' : 'grey'">mdi-apps</v-icon></v-avatar>
              </div>
              <span class="d-block text-caption text-truncate" :class="computedValue === null ? 'font-weight-black primary--text' : 'font-weight-medium'">همه</span>
            </v-col>

            <v-col cols="4" sm="3" class="text-center" v-for="(item, i) in items" :key="`modal-cat-${i}`" @click="selectCategoryAndCloseModal(i)">
              <div class="cat-avatar-wrapper modal-cat-wrapper mx-auto mb-2 transition-swing" :class="{'active-modal-wrapper': computedValue === i}">
                <v-avatar size="76" class="cat-avatar elevation-1">
                  <v-img v-if="!!item.picture" :src="item.picture" style="object-fit: cover"/>
                  <v-icon v-else size="36" :color="computedValue === i ? 'primary' : 'grey'">mdi-food</v-icon>
                </v-avatar>
              </div>
              <span class="d-block text-caption text-truncate" :class="computedValue === i ? 'font-weight-black primary--text' : 'font-weight-medium grey--text text--darken-2'">{{ item.name }}</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>

    <!-- ========================================== -->
    <!-- 4. مُدال همه زیردسته‌ها -->
    <!-- ========================================== -->
    <v-bottom-sheet v-model="showAllSubCategoriesModal" scrollable v-if="getSubs && getSubs.length">
      <v-card class="rounded-t-xl pb-4">
        <v-card-title class="d-flex justify-space-between align-center pb-2 pt-4">
          <span class="text-h6 font-weight-black">زیردسته‌ها</span>
          <v-btn icon color="grey" @click="showAllSubCategoriesModal = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-4" style="max-height: 60vh;">
          <v-row>
            <v-col cols="4" sm="3" @click="clearSubCategorySelection">
              <div class="sub-cat-card mx-auto transition-swing" :class="{'active-modal-sub-card': !computedFilters.sub}">
                <v-avatar size="56" class="mb-2 elevation-1"><v-icon size="28" :color="!computedFilters.sub ? 'primary' : 'grey'">mdi-format-list-bulleted</v-icon></v-avatar>
                <span class="text-caption font-weight-bold text-truncate w-100 px-1 text-center" :class="!computedFilters.sub ? 'primary--text' : 'grey--text'">همه</span>
              </div>
            </v-col>
            <v-col cols="4" sm="3" v-for="(item, i) in getSubs" :key="`modal-sub-${i}`" @click="selectSubCategoryAndCloseModal(item.id)">
              <div class="sub-cat-card mx-auto transition-swing" :class="{'active-modal-sub-card': computedFilters.sub === item.id}">
                <v-avatar size="56" class="mb-2 elevation-1">
                  <v-img v-if="item.picture" :src="item.picture" style="object-fit: cover"/>
                  <v-icon v-else size="28" :color="computedFilters.sub === item.id ? 'primary' : 'grey'">mdi-shape-outline</v-icon>
                </v-avatar>
                <span class="text-caption font-weight-bold text-truncate w-100 px-1 text-center" :class="computedFilters.sub === item.id ? 'primary--text' : 'grey--text text--darken-2'">{{ item.name }}</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-bottom-sheet>

  </div>
</template>

<script>
import SwiperWrapper from "@/view/pages/businessPage/components/cm/swiperWrapper";

export default {
  name: "mCategoryView",
  components: { SwiperWrapper },
  props: {
    value: Number,
    items: {
      type: Array,
      default: () => []
    },
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    rerender: true,
    showAllCategoriesModal: false,
    showAllSubCategoriesModal: false,
  }),
  computed: {
    computedValue: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    },
    computedFilters: {
      get() { return this.filters; },
      set(val) { this.$emit('update:filters', val); }
    },
    getSubs() {
      if (!this.items || this.computedValue === null || this.computedValue === undefined) {
        return [];
      }
      const category = this.items[this.computedValue];
      return category?.subCategories || category?.children || [];
    }
  },
  watch: {
    items: {
      deep: true,
      handler() {
        this.rerenderSwiper();
      }
    },
    showAllCategoriesModal(val) {
      this.$root.$emit('sheet-state-change', val);
    },
    showAllSubCategoriesModal(val) {
      this.$root.$emit('sheet-state-change', val);
    }
  },
  methods: {
    rerenderSwiper() {
      this.rerender = false;
      this.$nextTick(() => { this.rerender = true; });
    },
    selectCategory(index) {
      if (this.computedValue === index) return;
      this.computedValue = index;
      this.computedFilters.sub = null;
      if (this.$refs.swiper) {
        this.$refs.swiper.getSwiper().slideTo(index);
      }
    },
    selectSubCategory(id) {
      if (this.computedFilters.sub === id) {
        this.computedFilters.sub = null;
      } else {
        this.computedFilters.sub = id;
      }
      this.$emit('update:filters', this.computedFilters);
    },
    selectCategoryAndCloseModal(index) {
      this.selectCategory(index);
      this.showAllCategoriesModal = false;
    },
    clearCategorySelection() {
      this.computedValue = null;
      this.computedFilters.sub = null;
      this.showAllCategoriesModal = false;
    },
    selectSubCategoryAndCloseModal(id) {
      this.selectSubCategory(id);
      this.showAllSubCategoriesModal = false;
    },
    clearSubCategorySelection() {
      this.computedFilters.sub = null;
      this.$emit('update:filters', this.computedFilters);
      this.showAllSubCategoriesModal = false;
    }
  }
}
</script>

<style lang="scss">
.m-category-view {
  --gold-color: #D4AF37;
  --primary-color-var: var(--v-primary-base, #0d8ddc);

  /* برای جلوگیری از بریده شدن سایه در Swiper */
  .swiper-container {
    overflow: visible !important;
  }

  /* ========================================== */
  /* استایل دسته‌های اصلی (حالت شیشه‌ای) */
  /* ========================================== */
  .cat-slide {
    width: 96px !important;
    position: relative;
    cursor: pointer;
    user-select: none;
    padding-bottom: 20px; 
  }

  .cat-avatar-wrapper {
    position: relative;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid var(--gold-color);
    box-shadow: 0 4px 10px rgba(0,0,0,0.05);

    /* استایل شیشه‌ای (Glassmorphism) */
    background: rgba(255, 255, 255, 0.45);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);

    &.modal-cat-wrapper { width: 88px; height: 88px; }
  }

  .cat-avatar {
    background-color: transparent !important; /* حذف رنگ ثابت برای نمایش بهتر شیشه */
  }

  .cat-name-box {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    border: 2px solid var(--gold-color);
    border-radius: 12px;
    padding: 2px 6px;
    text-align: center;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);

    /* استایل شیشه‌ای */
    background: rgba(255, 255, 255, 0.75);
  }

  /* ========================================== */
  /* استایل دسته‌های اصلی (حالت شیشه‌ای) */
  /* ========================================== */
  .cat-slide {
    width: 96px !important;
    position: relative;
    cursor: pointer;
    user-select: none;
    padding-bottom: 20px; 
  }

  .cat-avatar-wrapper {
    position: relative;
    width: 88px;
    height: 88px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid var(--gold-color);
    box-shadow: 0 4px 10px rgba(0,0,0,0.05);

    /* استایل شیشه‌ای (Glassmorphism) */
    background: rgba(255, 255, 255, 0.45);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);

    &.modal-cat-wrapper { width: 88px; height: 88px; }
  }

  .cat-avatar {
    background-color: transparent !important; /* حذف رنگ ثابت برای نمایش بهتر شیشه */
  }

  .cat-name-box {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    border: 2px solid var(--gold-color);
    border-radius: 12px;
    padding: 2px 6px;
    text-align: center;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);

    /* استایل شیشه‌ای */
    background: rgba(255, 255, 255, 0.75);
  }

  .cat-text {
    color: #333;
    line-height: 1.4;
  }

  /* حالت فعال دسته اصلی */
  .active-cat .cat-avatar-wrapper, .active-modal-wrapper {
    border: 3px solid var(--primary-color-var);
    box-shadow: 0 6px 15px rgba(13, 141, 220, 0.25);
  }

  .active-cat .cat-name-box {
    border-color: var(--primary-color-var);
    padding: 6px !important;

    /* آبی شیشه‌ای برای حالت انتخاب شده */
    background: rgba(13, 141, 220, 0.85);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
  }

  .active-cat .cat-name-box .cat-text {
    color: white;
  }

  /* ========================================== */
  /* استایل زیردسته‌ها (کپسول‌های شیشه‌ای) */
  /* ========================================== */
  .sub-cat-slide {
    width: auto !important; 
    user-select: none;
  }

  .sub-cat-pill {
    display: flex;
    align-items: center;
    height: 48px;
    border: 2px solid var(--gold-color);
    border-radius: 30px;
    padding: 4px 16px 4px 6px;
    cursor: pointer;
    white-space: nowrap; 
    box-shadow: 0 3px 8px rgba(0,0,0,0.07);

    /* استایل شیشه‌ای */
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter:rgba(141, 220, 0.15);
    
    background: rgba(13, 141, 220, 0.15);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }
}
</style>
